// Performance monitoring utilities
export const measureBundleSize = () => {
  if (process.env.NODE_ENV === "development") {
    return;
  }

  // Monitor Core Web Vitals
  if ("PerformanceObserver" in window) {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.entryType === "largest-contentful-paint") {
          console.log("LCP:", entry.startTime);
        }
        if (entry.entryType === "first-input") {
          console.log("FID:", entry.processingStart - entry.startTime);
        }
        if (entry.entryType === "layout-shift") {
          console.log("CLS:", entry.value);
        }
      }
    });

    observer.observe({
      entryTypes: ["largest-contentful-paint", "first-input", "layout-shift"],
    });
  }
};

export const measureComponentLoadTime = (componentName) => {
  const startTime = performance.now();

  return () => {
    const loadTime = performance.now() - startTime;
    console.log(`${componentName} loaded in ${loadTime.toFixed(2)}ms`);
  };
};

export const logBundleInfo = () => {
  if (process.env.NODE_ENV === "development") {
    console.log("Bundle optimization applied:");
    console.log("- GSAP replaced with CSS animations");
    console.log("- react-icons consolidated to lucide-react");
    console.log("- Additional lazy loading implemented");
    console.log("- Tree shaking enabled");
  }
};
